module.exports = require('./electrum-ecies')
